module.exports = __webpack_public_path__ + "static/media/emj11.57871746.svg";